import { lenis } from '../layout/lenis';

const bars = document.querySelectorAll('.progress-scroll');

function getProgressScroll(scrollY, target) {
  if (target) {
    const elementTop = target.getBoundingClientRect().top + scrollY;
    const elementHeight = target.offsetHeight;
    const windowHeight = window.innerHeight;

    const scrolled = scrollY - elementTop + windowHeight;
    const total = elementHeight + windowHeight;
    return Math.min(Math.max(scrolled / total, 0), 1);
  }

  const total = document.documentElement.scrollHeight - window.innerHeight;
  return total > 0 ? Math.min(Math.max(scrollY / total, 0), 1) : 0;
}

function updateBars(scrollY) {
  bars.forEach(bar => {
    const target = bar.dataset.target
      ? document.querySelector(bar.dataset.target)
      : null;

    const progress = getProgressScroll(scrollY, target);
    bar.style.setProperty('--progress', progress);
    bar.style.width = `${progress * 100}%`;
  });
}

if (lenis) {
  lenis.on('scroll', ({ scroll }) => updateBars(scroll));
} else {
  window.addEventListener('scroll', () => updateBars(window.scrollY), {
    passive: true,
  });
}

updateBars(window.scrollY);

// <div class="progress-scroll"></div>
// <div class="progress-scroll" data-target="#section"></div>
